import { SearchActionConstants } from "../action-constants";
import { SearchActionCreators } from "../action-creators";
import { SearchHistoryUtils } from "../../utils";

export const SearchHistoryMiddleware = store => next => action => {
  switch (action.type) {
    case SearchActionConstants.INIT_HISTORY: {
      const existingHistory = SearchHistoryUtils.getPersistedSearchHistory();

      store.dispatch(SearchActionCreators.updateHistory(existingHistory));
      break;
    }

    case SearchActionConstants.SET_HISTORY: {
      const searchResult = action.payload;
      const newHistory = SearchHistoryUtils.updateSearchHistory(searchResult);

      return store.dispatch(SearchActionCreators.updateHistory(newHistory));
    }

    case SearchActionConstants.CLEAR_HISTORY: {
      SearchHistoryUtils.clearSearchHistory();
      return store.dispatch(SearchActionCreators.updateHistory());
    }

    default: {
      break;
    }
  }
  return next(action);
};
